// extracted by mini-css-extract-plugin
export default {"skillsCommunityStatus":"style_skillsCommunityStatus__+nB4l","skillsItem":"style_skillsItem__jXSri","tags":"style_tags__FVTdz","edit":"style_edit__wOgXH"};